
import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import Dashboard from "@/components/Dashboard";
import { ProviderManagement } from "@/components/ProviderManagement";
import { CalendarScheduling } from "@/components/CalendarScheduling";
import { ProviderProfile } from "@/components/ProviderProfile";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/useAuth";
import PatientInvitations from "./PatientInvitations";
import PatientManagement from "./PatientManagement";
import PatientDetailPage from "./PatientDetail";
import DoctorPatientDashboardPage from "./DoctorPatientDashboard";
import { PatientRoutes } from "@/routes/PatientRoutes";
import { TriageManagement } from "@/components/triage/TriageManagement"; // For triage queue

const Index = () => {
  const { profile } = useAuth();

  // Create provider data from actual profile information
  const providerData = profile ? {
    id: profile.id,
    name: `${profile.first_name} ${profile.last_name}`,
    email: profile.email,
    phone: profile.phone || "",
    specialty: "General Medicine", // Default value
    bio: "", // Default empty value
    workingHours: "9:00 AM - 5:00 PM", // Default value
    // Empty booking link for doctor/admin UI (required by Provider type)
    bookingLink: "",
    qrCode: "", // Default empty value
    status: "active" as const,
  } : null;

  // Check if user is a patient - based on profile role
  const isPatient = profile?.role === "patient";

  // For patient users, we'll use the new PatientRoutes component with the improved UI/UX
  if (isPatient) {
    return (
      <div className="min-h-screen bg-gray-50">
        {/* Patient routes with new layout structure */}
        <Routes>
          <Route path="/patient/*" element={<PatientRoutes />} />
          <Route path="*" element={<Navigate to="/patient/dashboard" replace />} />
        </Routes>
      </div>
    );
  }
  
  // For staff, doctors, and admins, we'll keep the existing sidebar layout
  return (
    <div className="min-h-screen bg-gray-50">
      <SidebarProvider>
        <div className="flex w-full min-h-screen">
          <Sidebar />
          <main className="flex-1 p-6">
            {isPatient ? (
              <PatientRoutes />
            ) : (
              <Routes>
                <Route index element={<Dashboard />} />
                <Route path="/providers" element={<ProviderManagement />} />
                <Route path="/calendar" element={<CalendarScheduling />} />
                <Route path="/patients" element={<PatientManagement />} />
                <Route path="/patients/:id" element={<DoctorPatientDashboardPage />} />
                <Route path="/invitations" element={<PatientInvitations />} />
                <Route path="/profile" element={<ProviderProfile provider={providerData} isOwnProfile={true} />} />
                <Route path="/triage" element={<TriageManagement />} />
              </Routes>
            )}
          </main>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default Index;
